import { gql } from '@apollo/client';

const PICK = 'races wins places roi';
const BUCKET = `key races favWins favPlaces tip { ${PICK} } consensus { ${PICK} } medianWinnerSp winnersShort winnersMid winnersLong`;

export const GET_TRACK_INSIGHTS = gql`
  query GetTrackInsights($trackCode: String!, $window: String, $condition: String) {
    trackInsights(trackCode: $trackCode, window: $window, condition: $condition) {
      trackCode
      trackName
      races
      overall { ${BUCKET} }
      byRaceNumber { ${BUCKET} }
      byClass { ${BUCKET} }
      byDistance { ${BUCKET} }
      byCondition { ${BUCKET} }
      byFieldSize { ${BUCKET} }
      barriers { distanceBand barrier runners wins winIndex }
      settling { distanceBand style winners winnerPct }
      marketRanks { key runners wins places roi }
      jockeys { name rides wins roi }
      trainers { name rides wins roi }
    }
  }
`;

export const GET_TRACK_INSIGHT_TRACKS = gql`
  query GetTrackInsightTracks {
    trackInsightTracks { trackCode trackName state races }
  }
`;
